import React from 'react';
import footorLogo from '../images/KNS2.png';

function Footer() {
    return (
        <div className='footer'>
            <div class="left-nav">
                <div class="logo">
                    <img src={footorLogo} alt='KNS'/>
                </div>
                    
                <div class="copyright">
                    <p>Copyright 2021 &copy; <a href="https://chrisbin95.github.io/Portfolio/">Chrisbin&#9811;</a></p>
                </div>
            </div>
        
            <div class="right-nav">
                <div class="menu">
                    <a href="#">Terms&nbsp; |</a>
                    <a href="#">Privacy Policy&nbsp; |</a>
                    <a href="#">Cookie Policy</a>
                 </div>
            </div>
        </div>
    )
}

export default Footer
